import Footer from "../../Components/Footer";
import { LoginForm } from "../../Components/LoginForm";
import { Container, FormContainer } from "./style";

const Home = () => {
  return (
    <Container>
      <FormContainer>
        <LoginForm />
      </FormContainer>
      <Footer />
    </Container>
  );
};
export default Home;
